import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ClientService } from '../../../@core/data/clients/client.service';
import {
  WorksheetService,
  WorksheetTicketSeverity,
  WorksheetTicketSeverityLabel,
  WorksheetTicketStatus,
  WorksheetTicketStatusLabel
} from '../../../@core/data/worksheets/worksheet.service';
import { AsconActions } from "../../team/view-team/view-team.component";
import { CookieService } from "ngx-cookie-service";
import { ContaTicketsFormComponent } from "../conta-tickets-form/conta-tickets-form.component";
import { Observable, Subject } from "rxjs";
import { ConfirmActionModalComponent } from '../../clients/confirm-action-modal/confirm-action-modal.component';
import { getUserById, getUsersById } from "../../../store/users/users.selectors";
import { getLoggedUser } from "../../../store/users/users.selectors";
import { Store } from "@ngrx/store";
import { IAppState } from "../../../store/app.state";
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { SupportTicketsService } from '../../../@core/data/support-tickets/supportTickets.service';

const _ = require('lodash');

@Component({
  selector: 'ngx-conta-tickets-modal',
  templateUrl: 'conta-tickets-modal.component.html',
  styleUrls: ['conta-tickets-modal.component.scss']
})
export class ContaTicketsModalComponent implements OnInit {

  @Input() clientId;
  public legalForm: any;
  public client: any = {};
  columns: any = [];
  tickets: any = [];
  public canSend473Email;
  public user;
  public selectAll = false;
  isSpinnerActive: boolean = false;
  userId: string;
  public ticketSeverity = WorksheetTicketSeverity;
  public ticketSeverityLabel = WorksheetTicketSeverityLabel;
  public ticketStatusLabel = WorksheetTicketStatusLabel;
  public ticketStatuses = WorksheetTicketStatus;
  public areOlderTicketsVisible = true;
  departments = ['IT', 'HR', 'JURIDIC', 'FONDURI EU'];
  sort = {
    column: 'date',
    order: 'DESC'
  };

  filter = {
    userId: '',
    toUserId: '',
  };
  userFromStore;

  public usersFilterOptions = [];
  public usersFilterOptionsKeys: string[] = [];
  public isFilterActive = false;
  public filteredTickets = [];
  public users = {};
  subject = new Subject<void>();
  constructor(protected ref: NbDialogRef<ContaTicketsModalComponent>,
    private clientService: ClientService,
    private dialogService: NbDialogService,
    private cookieService: CookieService,
    private worksheetService: WorksheetService,
    private store: Store<IAppState>,
    private supportTicketsService: SupportTicketsService
  ) {

    this.userId = localStorage.getItem('userId') || this.cookieService.get('UserId');

    this.store.select(getLoggedUser).pipe(takeUntil(this.subject)).subscribe((user) => { 
      if (!user?.user_id) return;
      this.user = {...user};
      this.canSend473Email = this.user?.actions?.some(action => action.action_id == AsconActions.Send473Email);
    });
  }

  ngOnDestroy () {
    this.subject.next();
  }

  ngOnInit() {
    this.store.select(getUsersById).subscribe(clients => {
      this.users = clients;
    })
    this.getClient();
    this.getTickets();
  }

  setColumns() {
 
    const allUserIds = _.uniq(
      _.flatMap(this.tickets, ticket => [ ticket.userId, ticket.toUserId ])
    );
    this.usersFilterOptionsKeys = allUserIds;
 
    this.usersFilterOptions = _.zipObject(this.usersFilterOptionsKeys, this.usersFilterOptionsKeys.map((userId) => {
      const ticket = this.tickets.find(ticket => ticket.userId == userId);
      return ticket && (this.users[userId]?.user_firstname || this.users[userId]?.user_lastname) ? `${this.users[userId]?.user_firstname} ${this.users[userId]?.user_lastname}` : userId;
    }));
    this.departments.forEach(dept => {
      this.usersFilterOptionsKeys.push(dept);
      this.usersFilterOptions[dept] = dept;
    });
 
    this.userFromStore = (userId) => { return this.store.select(getUserById(userId)); };
    this.columns = [
      {
        name: 'Acțiuni',
        class: 'ticket-action h-100',
        enabled: true,
        checkbox: false
      },
      {
        name: 'Numar',
        class: 'ticket-number h-100',
        enabled: true,
        checkbox: false,
        sortable: true,
        sortKey: 'id'
      },
      {
        name: 'Deschis de',
        class: 'ticket-date h-100',
        sortable: true,
        sortKey: 'userId',
        hasInputFilter: true,
        filter: 'userId',
        filterFunction: (state) => {
          this.filter.userId = state;
          this.filterTickets();
        },
        enabled: true,
        hasFilter: true,
        filterOptionsKeys: this.usersFilterOptionsKeys,  
        filterOptions: this.usersFilterOptions
      },
      {
        name: 'Pentru',
        class: 'ticket-user h-100',
        sortable: false,
        enabled: true,
        hasInputFilter: true,
        filter: 'toUserId',
        hasFilter: true,
        filterOptionsKeys: this.usersFilterOptionsKeys,
        filterOptions: this.usersFilterOptions,
        filterFunction: (value) => {
          this.filter.toUserId = value;
          this.filterTickets();
        },
      },
      {
        name: 'Dată',
        class: 'ticket-date h-100',
        sortable: true,
        sortKey: 'day',
        enabled: true
      },
      {
        name: 'Problemă',
        class: 'ticket-issue h-100',
        sortable: false,
        sortKey: 'registration_number',
        enabled: true
      },
      {
        name: 'Importanță',
        class: 'ticket-severity h-100',
        sortable: true,
        sortKey: 'severity',
        enabled: true
      },
      {
        name: 'Status',
        class: 'ticket-status h-100',
        sortable: true,
        sortKey: 'status',
        enabled: true
      }];
    this.columns = this.columns.filter(c => c.enabled);
   
  }

  dismiss(data: any) {
    this.ref.close(data);
  }

  createTicket() {
    this.dialogService.open(ContaTicketsFormComponent, {
      context: {
        ticketObj: { clientId: this.clientId, client: { client_name: this.client?.client_name } }
      }
    }).onClose.subscribe((data: any) => {
      this.getTickets();
    });
  }

  getTickets() {
    this.isSpinnerActive = true;
    this.tickets = [];
  
    let query = new Observable();
  
    if (this.clientId) {
      query = this.worksheetService.getTickets(this.clientId);
    } else {
      query = this.worksheetService.getTicketsByUserId(this.userId);
    }
  
    query.subscribe((tickets: any) => {
      this.tickets = tickets?.data.map((ticket) => ({
        ...ticket,
        id: parseInt(ticket?.id) ?? ticket?.id,
        day:
          moment
            .utc((ticket?.date || 0) / 1000, 'X')
            .startOf('day')
            .unix() * 1000
      }));

      this.tickets = this.tickets.filter(ticket =>
        ticket.toUserId === this.userId || ticket.userId === this.userId ||
        this.departments.includes(ticket?.category)
      );

      this.tickets = _.orderBy([].concat(this.tickets || []), ['day', 'status'], ['desc', 'desc']);
      this.tickets = this.tickets.map(ticket => {
        if (ticket.category === 'IT' && !isNaN(Number(ticket.status))) {
            ticket.status = this.mapItStatusToContaStatus(ticket.status);
        }
        return ticket;
    });
      this.filterTickets();
      this.setColumns();
      this.isSpinnerActive = false;
    });
  }

  filterTickets() {
    this.filteredTickets = this.tickets.filter(ticket => {
      let state = true;
      Object.keys(this.filter).forEach(f => {
        if (this.filter[f]) {
          this.isFilterActive = true;
          if (f === 'description') {
            state = state && ticket.description.includes(this.filter[f]);
          } else if (f === 'toUserId' && this.departments.includes(this.filter[f])) {
            state = state && ticket.category == this.filter[f];
          } else if (f === 'userId' && this.departments.includes(this.filter[f])) {
            state = state && ticket.category == this.filter[f];
          } else {
            state = state && ticket[f] == this.filter[f];
          }
        }
      });
      return state;
    });

    if (this.areOlderTicketsVisible) {
      const threshold = moment().subtract(3, 'months').startOf('month').valueOf();
      this.filteredTickets = this.filteredTickets.filter(ticket => {
        return ticket.day > threshold || ticket.status != 'closed';
      });
    }
  }

  onToggleOlderTickets(event: boolean): void {
    this.areOlderTicketsVisible = event;
    this.filterTickets();
  }

  resetFilters() {
    this.isFilterActive = false;
    this.filter = {
      userId: '',
      toUserId: '',
    };
    this.filterTickets();
  }

  getClient() {
    const data = this.clientService.getClientById(this.clientId);
    data.subscribe((detailsResponse: any) => {
      this.client = detailsResponse.data;
    });
  }

  deleteTicket(detail: any) {
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Esti sigur ca doresti sa stergi?`,
          withConsent: true
        }
      })
      .onClose.subscribe((res: any) => {
        if (res) {
          this.worksheetService.deleteTicket(detail.id)
            .subscribe((response: any) => {
              this.tickets = this.tickets.filter(p => p.id !== detail.id);
            });
        }
      });
  }

  markAsRepetitiveIssue(issue: any) {
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Ești sigur că dorești să marchezi întrebarea ca repetitivă?`,
          withConsent: true
        }
      })
      .onClose.subscribe((res: any) => {
        if (res) {
          this.worksheetService.setRepetitiveIssue(issue)
            .subscribe((res:any) => {
              this.tickets = this.tickets.map((ticket) => (
                {
                  ...ticket,
                  repetitiveIssue: res.status && res.data === ticket.id ? 'true' : ticket.repetitiveIssue
                }
              ));
              this.filterTickets();
            });
        }
      });
  }

  editDetail(ticket) {
    this.dialogService.open(ContaTicketsFormComponent, {
      context: {
        ticketObj: ticket
      }
    });
  }

  closeModal() {
    if (this.tickets)
      this.dismiss(this.tickets.length);
  }

  closeIssue(ticket) {
    this.dialogService.open(ConfirmActionModalComponent, {
      context: {
        title: 'Închidere tichet',
        description: 'Ești sigur că dorești să închizi acest tichet?',
        withConsent: true
      }
    }).onClose.subscribe((confirmed: any) => {
      if (confirmed){
        this.worksheetService.closeTicket(ticket).subscribe((res:any)=>{
          if (res.status){
            ticket['status'] = 'closed';
          }
          this.filterTickets();
        });
      }
    });
  }

  toggleAll() {
    this.selectAll = !this.selectAll;
    setTimeout(() => {
      this.tickets = this.tickets.map(detail => {
        if (detail.status != 2) {
          detail.checkbox = this.selectAll;
        }
        return detail;
      });
    });
  }

  sortTickets(column, noChangesInSort) {
    if (noChangesInSort) {
      this.filteredTickets = _.orderBy([].concat(this.filteredTickets || []), [this.sort.column['sortKey']], [this.sort.order]);
      return;
    }

    if (column.sortable) {
      let order = 'asc';
      if (this.sort.column !== column) {
        order = 'asc';
      } else {
        order = this.sort.order === 'asc' ? 'desc' : 'asc';
      }
      this.sort = {
        column: column,
        order: order
      };
      this.columns.forEach(c => c['order'] = null);
      column.order = order;
      this.filteredTickets = _.orderBy([].concat(this.filteredTickets || []), [column.sortKey], [order]);
    }
  }

  private mapItStatusToContaStatus(itStatus: string | number): string {
    const mapping = {
        '0': 'open',     
        '1': 'solving',   
        '2': 'solving',   
        '3': 'closed',   
        '4': 'solving',  
        '5': 'solving',   
    };
    return mapping[String(itStatus)] || String(itStatus);
}

}
